import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { DEFAULT_FONT_FAMILY_ITALIC, DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
/** Format the success message after editing the member role */
export function RoleChangeSuccessDescription(t0) {
  const $ = _c(4);
  const {
    role
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontSize: DEFAULT_INPUT_FONT_SIZE
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: DEFAULT_FONT_FAMILY_ITALIC
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== role) {
    t3 = <Box component="div" sx={t1}>New Role:{" "}<Box component="span" sx={t2}>"{role}"</Box></Box>;
    $[2] = role;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}